import LinkRenderer from "./LinkRenderer"
import Link from "./Link"
import Quote from "./Quote"
import Icon from "./Icon"

import Block from "./Block"
import Doc from "./Doc"
import Slideshow from "./Slideshow"
import Slide from "./Slide"
import Action from "./Action"
import DocList from "./DocList"
import Card from "./Card"
import CardList from "./CardList"
import MinicardList from "./MinicardList"
import Minicard from "./Minicard"
import SimpleIcon from "./SimpleIcon"
import Folder from "./Folder"
import State from "./State"
import Breadcrumb from "./Breadcrumb"
import Search from "./Search"

const fieldRenderer = {
    Block,
    LinkRenderer,
    Link,
    Icon,
    Quote,
    doc: Doc,
    Slideshow,
    Slide,
    Action,
    DocList,
    Card,
    CardList,
    MinicardList,
    Minicard,
    SimpleIcon,
    Folder,
    State,
    Breadcrumb,
    Search,
}
export default fieldRenderer
